var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "agreementContainer" } }, [
    _c("div", { attrs: { id: "agreement" } }, [
      _c("div", { domProps: { innerHTML: _vm._s(_vm.agreementText) } }),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("input", {
        attrs: {
          type: "checkbox",
          id: "terms-conditions",
          required: "required",
        },
        domProps: { checked: _vm.isChecked },
        on: {
          change: function ($event) {
            return _vm.setIsAgreementAccepted()
          },
        },
      }),
      _vm._v(" "),
      _c("label", { attrs: { for: "terms-conditions", id: "confirmation" } }, [
        _vm._v(_vm._s(_vm.confirmationText)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }